// src/app/slices/filterSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FilterState, IFilter, IFilterParams } from '../models';

const initialState: FilterState = {
  filters: {},
  filter_params: null,
};

const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setFilter: (state, action: PayloadAction<IFilter>) => {
      state.filters[action.payload.id] = action.payload;
    },
    setFilterParams: (state, action: PayloadAction<IFilterParams>) => {
      state.filter_params = action.payload;
    },
  },
});

export const { setFilter, setFilterParams } = filterSlice.actions;

export default filterSlice.reducer;
